<template>
  <div>
    <div v-wechat-title="'《最强蜗牛》五周年版本上线！'"></div>
    <div class="pc-page">
      <div class="logo"></div>
      <div class="banner"></div>
      <div class="qrcode-box"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp , buriedLogger } from '@/utils/utils';
import { mapActions } from 'vuex';
export default {
  components: {},
  data () {
    return {
      enterLink: '',
    };
  },
  created () {
    const bl = buriedLogger("snail", "五周年庆_PC端");
    this.logger = bl;
  },
  mounted () {
    this.$nextTick(() => {
      // 分享
      this.enterLink = 'https://h5.qingcigame.com/snail/recall/anniversary';
      this.monitoringEquipment(this.enterLink);
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  methods: {
    monitoringEquipment(linkUrl) {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `${linkUrl}${getTimeStamp()}`
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '《最强蜗牛》五周年版本上线',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/sTsPyCJ08V30Y19cL9SoXTH5RFXqt6eaC3v60hP6.png',
        desc: '什么！百抽都成基础福利了？',
      })
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/recall/pc/index.vue